import { useFormContext } from 'react-hook-form';
import { IDetailsFormData } from '../types/IDetailsFormData';

export function useDetailsFormContext() {
	return useFormContext<IDetailsFormData>();
}
